// import React, { useEffect, useState, useCallback } from "react";
// import SummaryApi from "../common/SummaryApi";
// import { toast } from "react-hot-toast";
// import SelectDropdown from "../customStyles/SelectDropdown";
// import CustomDatePicker from "../customStyles/CustomDatePicker";
// import Breadcrumb from "../components/BreadCrumb";
// import { IoMail } from "react-icons/io5";
// import { useSelector } from "react-redux";
// import { useDispatch } from "react-redux";
// import { setUserDetails } from "../store/userSlice";

// const ProfilePage = () => {
//   const user = useSelector((state) => state?.user?.user);
//   const [loading, setLoading] = useState(false);
//   const token = localStorage.getItem("token");
//   const [initialData, setInitialData] = useState(null);
//   console.log(user);
  

//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     gender: "",
//     birthday: "",
//     email: "",
//     phone: "",
//   });

//   const genderOptions = [
//   { id: "male", label: "Male" },
//   { id: "female", label: "Female" },
// ];

// const isChanged =
//   initialData &&
//   JSON.stringify(formData) !== JSON.stringify(initialData);

//   /* ================= FETCH PROFILE ================= */
//   const fetchProfile = useCallback(async () => {
//     try {
//       setLoading(true);

//       const res = await fetch(SummaryApi.getProfile.url, {
//         method: SummaryApi.getProfile.method,
//         headers: token ? { Authorization: `Bearer ${token}` } : {},
//       });

//       const result = await res.json();

//       if (result.success && result.data) {
//         const profileData = {
//           firstName: result.data.firstName || "",
//           lastName: result.data.lastName || "",
//           gender: result.data.gender || "",
//           birthday: result.data.birthday
//             ? result.data.birthday.slice(0, 10)
//             : "",
//           email: result.data.email || "",
//           phone: result.data.phone || "",
//         };

//         setFormData(profileData);
//         setInitialData(profileData); // ⭐ important
//       }

//     } catch {
//       toast.error("Failed to load profile");
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   useEffect(() => {
//     fetchProfile();
//   }, [fetchProfile]);

//   /* ================= HANDLE CHANGE ================= */
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   /* ================= UPDATE PROFILE ================= */
//   const handleSubmit = async () => {
//     if (!isChanged) {
//       toast.info("No changes to update");
//       return;
//     }

//     try {
//       setLoading(true);

//       const res = await fetch(SummaryApi.updateProfile.url, {
//         method: SummaryApi.updateProfile.method,
//         headers: {
//           "Content-Type": "application/json",
//           ...(token && { Authorization: `Bearer ${token}` }),
//         },
//         body: JSON.stringify({
//           firstName: formData.firstName,
//           lastName: formData.lastName,
//           gender: formData.gender,
//           birthday: formData.birthday,
//           phone: formData.phone,
//         }),
//       });

//       const data = await res.json();

//       if (data.success) {
//         toast.success("Profile updated successfully");
//         fetchProfile();
//       } else {
//         toast.error(data.message || "Update failed");
//       }
//     } catch {
//       toast.error("Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

// const inputClass =
//   "w-full px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-md text-sm placeholder:text-[#8F8D92] outline-none focus:border-gray-300 focus:ring-0";

//   return (
//     <div className="w-full space-y-5 bg-[#F3F4F8]">
//       {/* TITLE */}
//       <div>
//         <h2 className="hidden lg:block text-xl font-bold mb-2">Profile</h2>
//         <Breadcrumb
//           items={[
//             { label: "Home", path: "/" },
//             { label: "Profile" }
//           ]}
//         />
//       </div>

//       {/* NAME CARD */}
//       <div className="bg-white rounded-xl p-6">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           <div>
//             <label className="text-sm font-medium">First Name</label>
//             <input
//               name="firstName"
//               value={formData.firstName}
//               onChange={handleChange}
//               placeholder="Your First Name"
//               className={`${inputClass} mt-2`}
//             />
//           </div>

//           <div>
//             <label className="text-sm font-medium">Last Name</label>
//             <input
//               name="lastName"
//               value={formData.lastName}
//               onChange={handleChange}
//               placeholder="Your Last Name"
//               className={`${inputClass} mt-2`}
//             />
//           </div>
//         </div>
//       </div>

//       {/* DETAILS CARD */}
//       <div className="bg-white rounded-xl p-6 space-y-6">
//         {/* Gender & Birthday */}
// <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//   {/* Gender */}
//   <div>
//     <label className="text-sm font-medium">Gender</label>

//     <SelectDropdown
//       value={formData.gender}
//       onChange={(value) =>
//         setFormData((prev) => ({ ...prev, gender: value }))
//       }
//       options={genderOptions}
//       labelKey="label"
//       valueKey="id"
//       placeholder="Select Gender"
//       parentClassName="mt-2"
//       ChildClassName={inputClass}
//       iconSize={16}
//     />
//   </div>

//   {/* Birthday */}
//   <div>
//     <label className="text-sm font-medium">Birthday</label>

//     <CustomDatePicker
//       value={formData.birthday}
//       onChange={(date) =>
//         setFormData((prev) => ({
//           ...prev,
//           birthday: date,
//         }))
//       }
//       placeholder="DD-MM-YYYY"
//       containerClassName="mt-2"
//       inputClassName={inputClass}
//     />
//   </div>
// </div>


//         {/* EMAIL */}
// {/* EMAIL */}
// <div className="space-y-3">
//   {/* Title */}
//   <p className="text-sm font-medium">My email Address</p>

//   {/* Email Row */}
//   <div className="flex items-center justify-between">
//     <div className="flex items-center gap-3">
//       <div className="bg-blue-100 p-2 rounded-full">
//         <IoMail size={16} className="text-[#007BFF]" />
//       </div>
//       <p className="w-52 md:w-auto text-sm text-gray-700 truncate">
//         {formData.email}
//       </p>
//     </div>

//     {/* <button className="text-[#007BFF] text-sm font-medium">
//       Change Email
//     </button> */}
//   </div>
// </div>


//         {/* MOBILE */}
//         <div className="flex items-center justify-between">
//           <div className="w-full max-w-xs">
//             <label className="text-sm font-medium">Mobile Number</label>
//             <input
//               name="phone"
//               value={formData.phone}
//               onChange={handleChange}
//               placeholder="Enter Mobile Number"
//               className={`${inputClass} mt-2`}
//             />
//           </div>
//           <button className="text-[#007BFF] text-sm font-medium mt-6 ml-2 md:ml-0">
//             Change
//           </button>
//         </div>
//       </div>

//       {/* BUTTON */}
//       <button
//         onClick={handleSubmit}
//         disabled={loading || !isChanged}
//         className={`
//           w-full md:w-auto px-8 py-2 rounded-sm text-sm font-medium
//           ${isChanged ? "bg-[#007BFF] text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"}
//           disabled:opacity-60
//         `}
//       >
//         {loading ? "Updating..." : "UPDATE PROFILE"}
//       </button>
//     </div>
//   );
// };

// export default ProfilePage;

import React, { useEffect, useState } from "react";
import SummaryApi from "../common/SummaryApi";
import { toast } from "react-hot-toast";
import SelectDropdown from "../customStyles/SelectDropdown";
import CustomDatePicker from "../customStyles/CustomDatePicker";
import Breadcrumb from "../components/BreadCrumb";
import { IoMail } from "react-icons/io5";
import { useSelector, useDispatch } from "react-redux"; // useDispatch added
import { setUserDetails } from "../store/userSlice";

const ProfilePage = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.user); // Redux store data
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const [initialData, setInitialData] = useState(null);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    birthday: "",
    email: "",
    phone: "",
  });

  const genderOptions = [
    { id: "male", label: "Male" },
    { id: "female", label: "Female" },
    { id: "other", label: "Other" },
  ];

  // Redux - to get user details and set initial form data
  useEffect(() => {
    if (user) {
      const profileData = {
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        gender: user.gender || "",
        birthday: user.birthday ? user.birthday.slice(0, 10) : "",
        email: user.email || "",
        phone: user.phone || "",
      };
      setFormData(profileData);
      setInitialData(profileData);
    }
  }, [user]);

  const isChanged =
    initialData && JSON.stringify(formData) !== JSON.stringify(initialData);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= UPDATE PROFILE ================= */
  const handleSubmit = async () => {
    if (!isChanged) {
      toast.info("No changes to update");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(SummaryApi.updateProfile.url, {
        method: SummaryApi.updateProfile.method,
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          gender: formData.gender,
          birthday: formData.birthday,
          phone: formData.phone,
        }),
      });

      const data = await res.json();

      if (data.success) {
        toast.success("Profile updated successfully");
        // Redux store-data update
        dispatch(setUserDetails(data.data)); 
      } else {
        toast.error(data.message || "Update failed");
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-md text-sm placeholder:text-[#8F8D92] outline-none focus:border-gray-300 focus:ring-0";

  return (
    <div className="w-full space-y-5">
      {/* TITLE */}
      <div>
        <h2 className="hidden lg:block text-xl font-bold mb-2">Profile</h2>
        <Breadcrumb
          items={[
            { label: "Home", path: "/" },
            { label: "My Account", path: "/my-account/menu" },
            { label: "Profile" },
          ]}
        />
      </div>

      {/* NAME CARD */}
      <div className="bg-white rounded-xl p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="text-sm font-medium">First Name</label>
            <input
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="Your First Name"
              className={`${inputClass} mt-2`}
            />
          </div>

          <div>
            <label className="text-sm font-medium">Last Name</label>
            <input
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Your Last Name"
              className={`${inputClass} mt-2`}
            />
          </div>
        </div>
      </div>

      {/* DETAILS CARD */}
      <div className="bg-white rounded-xl p-6 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Gender */}
          <div>
            <label className="text-sm font-medium">Gender</label>
            <SelectDropdown
              value={formData.gender}
              onChange={(value) =>
                setFormData((prev) => ({ ...prev, gender: value }))
              }
              options={genderOptions}
              labelKey="label"
              valueKey="id"
              placeholder="Select Gender"
              parentClassName="mt-2"
              ChildClassName={inputClass}
              iconSize={16}
            />
          </div>

          {/* Birthday */}
          <div>
            <label className="text-sm font-medium">Birthday</label>
            <CustomDatePicker
              value={formData.birthday}
              onChange={(date) =>
                setFormData((prev) => ({
                  ...prev,
                  birthday: date,
                }))
              }
              placeholder="DD-MM-YYYY"
              containerClassName="mt-2"
              inputClassName={inputClass}
            />
          </div>
        </div>

        {/* EMAIL */}
        <div className="space-y-3">
          <p className="text-sm font-medium">My email Address</p>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="bg-blue-100 p-2 rounded-full">
                <IoMail size={16} className="text-[#007BFF]" />
              </div>
              <p className="w-52 md:w-auto text-sm text-gray-700 truncate">
                {formData.email}
              </p>
            </div>
          </div>
        </div>

        {/* MOBILE */}
        <div className="flex items-center justify-between">
          <div className="w-full max-w-xs">
            <label className="text-sm font-medium">Mobile Number</label>
            <input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter Mobile Number"
              className={`${inputClass} mt-2`}
            />
          </div>
          <button className="text-[#007BFF] text-sm font-medium mt-6 ml-2 md:ml-0">
            Change
          </button>
        </div>
      </div>

      {/* UPDATE BUTTON */}
      <button
        onClick={handleSubmit}
        disabled={loading || !isChanged}
        className={`
          w-full md:w-auto px-8 py-2 rounded-sm text-sm font-medium
          ${isChanged ? "bg-[#007BFF] text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"}
          disabled:opacity-60
        `}
      >
        {loading ? "Updating..." : "UPDATE PROFILE"}
      </button>
    </div>
  );
};

export default ProfilePage;